export interface LatLngTuple {
  lat: string | null;
  lon: string | null;
}

const coordinateRegex = /^-?(0|[1-9]\d*)(\.\d+)?$/;

export function isCoordinate(x: any): boolean {
  if (typeof x === 'number') x = String(x);
  if (typeof x !== 'string') return false;
  return coordinateRegex.test(x.trim());
}
